
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-1 -1 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 19a6 6 0 106 6 6 6 0 00-6-6z","fill":"var(--primary-highlight)","stroke":"#4fa2b7","stroke-miterlimit":"10","stroke-width":"4"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/pointFill.svg